<div class="empty-station-item" *ngIf="station"
    [ngClass]="{'disabled':station.stationUsage.suspended || station.stationUsage.disabled, 'selected': selected}">
    <sc-flex fitHeight [centered]="true" vertical>
        <div>
            <sc-flex >
                <div class="icon">
                    <sc-icon iconClass="fa-lock fa-2x" *ngIf="station.stationUsage.suspended"></sc-icon>
                    <sc-icon iconClass="fa-xmark fa-3x" *ngIf="station.stationUsage.disabled"></sc-icon>
                </div>
                <sc-content-spacer></sc-content-spacer>
                <div class="title">
                    {{station.name}}
                </div>
            </sc-flex>
        </div>
        <sc-content-spacer vertical [half]="true"></sc-content-spacer>
        <div *ngIf="station.stationUsage.suspended">{{station.stationUsage.note}}</div>
        <div *ngIf="station.stationUsage.loadingZoneLock">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.transport-details-list-entry.action.create-movement-order"></sc-dictionary-label>
        </div>
    </sc-flex>
</div>
